var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0297 5.11526L10.7097 2.09276C9.53219 1.26776 7.72469 1.31276 6.59219 2.19026L2.83469 5.12276C2.08469 5.70776 1.49219 6.90776 1.49219 7.85276V13.0278C1.49219 14.9403 3.04469 16.5003 4.95719 16.5003H13.0422C14.9547 16.5003 16.5072 14.9478 16.5072 13.0353V7.95026C16.5072 6.93776 15.8547 5.69276 15.0297 5.11526ZM9.56219 13.5003C9.56219 13.8078 9.30719 14.0628 8.99969 14.0628C8.69219 14.0628 8.43719 13.8078 8.43719 13.5003V11.2503C8.43719 10.9428 8.69219 10.6878 8.99969 10.6878C9.30719 10.6878 9.56219 10.9428 9.56219 11.2503V13.5003Z",
    fill: "#924E27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/home-active.1cf832b7494ea6eb502e520ffb8a657d.svg";
export { ForwardRef as ReactComponent };